export async function apiGet<T = any>(path: string): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'Accept': 'application/json' },
  })
  if (!res.ok) throw new Error(await safeText(res))
  return res.json() as Promise<T>
}

export async function apiPost<T = any>(path: string, body: any): Promise<T> {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body ?? {}),
  })
  if (!res.ok) throw new Error(await safeText(res))
  return res.json() as Promise<T>
}

export async function apiPut<T = any>(path: string, body: any): Promise<T> {
  const res = await fetch(path, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body ?? {}),
  })
  if (!res.ok) throw new Error(await safeText(res))
  return res.json() as Promise<T>
}

export async function apiDelete<T = any>(path: string, body?: any): Promise<T> {
  const res = await fetch(path, {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) throw new Error(await safeText(res))
  return res.json() as Promise<T>
}

async function safeText(res: Response) {
  try { return await res.text() } catch { return `${res.status} ${res.statusText}` }
}
